module.exports = __webpack_public_path__ + "img/pin-black.aa64a422.svg";